import React from "react";
import { Icon, message, Button, Card, Spin, Popover } from "antd";
import {
  WeaRightMenu,
  WeaTab,
  WeaInput,
  WeaTop,
  WeaNewScroll,
  WeaSelect
} from "ecCom";
import { stickMsgType, cancelStickMsgType } from "../../apis/index";

import WeaLocaleProvider from "../../../../ecology9/wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;

class MsgTypePanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoverId: "",
      currentIds: []
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.rightList.length !== this.props.rightList.length &&
      this.state.hoverId === ""
    ) {
      this.setState({
        currentIds: nextProps.rightList
          .filter(item => item.rank && item.rank !== "")
          .map(item => item.id)
          .reverse()
      });
    }
  }

  stickTop() {
    const { rightList } = this.props;
    const { currentIds, hoverId } = this.state;
    if (currentIds.includes(hoverId)) {
      currentIds.splice(currentIds.indexOf(hoverId), 1);
      cancelStickMsgType({ id: hoverId });
    } else {
      currentIds.push(hoverId);
      stickMsgType({ id: hoverId });
    }
    this.setState({ currentIds });
    currentIds.reverse();
    let newRightList = [];
    for (let i = 0; i < currentIds.length; i++) {
      for (let j = 0; j < rightList.length; j++) {
        if (currentIds[i] === rightList[j].id) {
          newRightList.push(rightList[j]);
          rightList.splice(j, 1);
          break;
        }
      }
    }
    currentIds.reverse();
    let tempArray = rightList;
    tempArray = tempArray.sort((a, b) => {
      return new Date(b.time) - new Date(a.time);
    });
    newRightList = newRightList.concat(...tempArray);
    this.props.setState({
      rightList: newRightList
    });
  }

  render() {
    const { options, moduleId, viewAttr, loading } = this.props;
    const { currentIds, hoverId } = this.state;
    const menu = [
      {
        key: "1",
        content: currentIds.includes(hoverId)
          ? getLabel("510155", "取消置顶")
          : getLabel("510077", "置顶消息"),
        onClick: () => this.stickTop()
      }
    ];
    return (
      <div>
        <div className="wea-messageCenter-rightList">
          <div className="search-panel">
            <Popover
              overlayClassName="wea-messageCenter-custom-popover"
              // overlayStyle={{ width: 168 }}
              content={
                <div className="wea-messageCenter-rightList-advancedSearch">
                  <p> {getLabel("504403", "消息种类")}: </p>
                  <div>
                    <WeaInput
                      value={this.props.keyword}
                      onChange={e => {
                        this.props.setState({
                          keyword: e
                        });
                      }}
                    />
                  </div>
                  <p> {getLabel("19049", "模块")}: </p>
                  {/* 由于 WeaSelect的设计在父级宽度 -3px， 导致这里只能 148 + 1 = 151 :( */}
                  <div>
                    <WeaSelect
                      style={{ width: 180 }}
                      options={options}
                      value={moduleId}
                      viewAttr={viewAttr}
                      widthMatchOptions={true}
                      onChange={v => {
                        this.props.setState({
                          moduleId: v
                        });
                      }}
                    />
                  </div>
                  <div
                    style={{
                      margin: "18px -10px 0",
                      height: 1,
                      background: "#ebebeb"
                    }}
                  />
                  <div style={{ textAlign: "center", marginBottom: 0 }}>
                    <Button
                      className="advanced-button"
                      onClick={() => this.props.advancedSearch("search")}
                      type="primary"
                    >
                      {getLabel("388113", "搜索")}
                    </Button>
                    &emsp;
                    <Button
                      className="advanced-button"
                      onClick={() => this.props.advancedSearch("reset")}
                    >
                      {getLabel("2022", "重置")}
                    </Button>
                  </div>
                </div>
              }
              placement="bottom"
              visible={this.props.searchVisible}
            >
              <div>
                <WeaInput
                  value={this.props.keyword}
                  placeholder={getLabel("500351", "请输入关键字")}
                  onChange={e => {
                    this.props.setState({
                      keyword: e
                    });
                  }}
                  onPressEnter={e => {
                    this.props.advancedSearch("search");
                  }}
                />
                <i
                  onClick={() => {
                    this.props.setState({
                      searchVisible: !this.props.searchVisible
                    });
                  }}
                  className={
                    this.props.keyword !== "" || this.props.moduleId !== ""
                      ? "icon-coms-screen2"
                      : "icon-coms-screen"
                  }
                />
              </div>
            </Popover>
          </div>
          <WeaRightMenu
            datas={menu}
            customMenu={data => {
              const res = data.splice(1, 2);
              // ie 9 兼容问题
              data.length = 1;
            }}
          >
            <WeaNewScroll
              height={
                this.props.offsetHeight === 0
                  ? 585
                  : 585 + this.props.offsetHeight
              }
            >
              <ul>
                {this.props.rightList.length > 0 &&
                  this.props.rightList.map(item => {
                    // 暂时不展示 [全部] 标签
                    if (item.id === "0") {
                      return false;
                    }
                    return (
                      <li
                        className={`item ${
                          item.id === this.props.current ? "active" : ""
                        } ${
                          this.state.currentIds.includes(item.id)
                            ? "sticky"
                            : ""
                        }`}
                        onClick={() => {
                          if (!loading) {
                            this.props.setState({
                              flag: true,
                              newMsgValue: "none",
                              current: item.id
                            });
                            this.props.changeRight(item.id, 0, 0, item);
                          }
                        }}
                        onContextMenu={() => {
                          this.setState({
                            hoverId: item.id
                          });
                        }}
                      >
                        <div>
                          <i className={"icon"}>
                            <img src={item.icon} alt="" />
                          </i>
                          <span class="title wea-f12" title={item.name}>
                            {item.name}
                          </span>
                          {Number(item.count) > 0 && (
                            <span className="num">{item.count}</span>
                          )}
                        </div>
                      </li>
                    );
                  })}
              </ul>
            </WeaNewScroll>
          </WeaRightMenu>
        </div>
      </div>
    );
  }
}

export default MsgTypePanel;



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/message-center/msg-type-panel.js